import React from 'react';
import { Redirect } from 'react-router-dom';
import { addRouteNamespace } from '@Utils/actions';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MapRedirect = (): JSX.Element => {
	return <Redirect to={addRouteNamespace('')} />;
};

export default MapRedirect;
